import {ApplicationController} from "../support/application-controller";
import {addEvent} from "../support/util";

export default class extends ApplicationController {
    static targets = [];
    initialize() {
        // Listen to the storage event for the logOut action across tabs
        localStorage.removeItem('userLogOut');
        addEvent(window, 'storage', this.localStorageChange, true);
    }

    signOut() {
        this.railsDelete({ url: `${this.signoutUrl}`, withCredentials: true, data: null }).then((data) => {
            // Set the local storage item userLogOut to true
            // so all other open tabs can handle this logout
            localStorage.setItem('userLogOut', true);

            if (data && data.redirectTo) {
                window.open(data.redirectTo, "_self");
            } else if (this.redirectUrl) {
                window.open(this.redirectUrl, "_self")
            } else {
                location.reload();
            }
        });
    }

    get signoutUrl() {
        return this.data.get("signoutUrl");
    }

    get redirectUrl() {
        return this.data.get("redirectOnSignoutUrl");
    }

    localStorageChange(e) {
        // In case userLogOut is set to true,
        // it means that the user logged out in another tab
        if (e.key === 'userLogOut' && e.newValue === 'true') {
            location.reload();
        }
    }
}
